// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4b82c6c9","703":"36f06bf2","787":"82de6108"}[chunkId] + ".chunk.js";
};